<div
  class="error-container flex flex-wrap align-items-center justify-content-center h-screen"
>
  <div class="text-center">
    <p class="title text-7xl pb-5">404 error</p>
    <p i18n="@@error404.text">Esta página no existe.</p>
    <p-button
      i18n-label="@@error404.button.home"
      routerLink="/"
      label="Inicio"
      icon="ph ph-house"
      styleClass="p-button-rounded p-button-sm uppercase"
    ></p-button>
  </div>
</div>
